import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { setLoadingHandlers } from "../services/loadingController";

const LoadingContext = createContext();
export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const requestCount = useRef(0);
  const hideTimeout = useRef(null);

  const showLoader = () => {
    requestCount.current += 1;
    if (hideTimeout.current) {
      clearTimeout(hideTimeout.current);
      hideTimeout.current = null;
    }
    setVisible(true); // Show loader immediately
  };

  const hideLoader = () => {
    requestCount.current = Math.max(0, requestCount.current - 1);
    if (requestCount.current === 0) {
      // Wait before hiding to prevent flicker
      hideTimeout.current = setTimeout(() => {
        setVisible(false);
      }, 800); // ⏳ adjust delay (300–500ms is good)
    }
  };

  useEffect(() => {
    setLoadingHandlers(showLoader, hideLoader);
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading: visible }}>
      {children}
    </LoadingContext.Provider>
  );
};
